<!-- 成功案例 -->
<template>
  <div class="cases">
    <div class="banner"></div>
    <div class="main">
      <div class="content">
        <div class="classify">
          <div class="categories">
            <!-- 动态渲染分类 -->
            <div class="category-group">
              <h3>类型：</h3>
              <ul>
                <li
                  :class="{
                    active: activeCategory === null,
                    'default-active': activeCategory === null,
                  }"
                  @click="selectCategory(null)"
                >
                  全部
                </li>
                <li
                  v-for="category in categoryList"
                  :key="category.id"
                  :class="{ active: activeCategory === category.id }"
                  @click="selectCategory(category.id)"
                >
                  {{ category.name }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="box">
          <div
            class="article"
            v-for="item in caseList"
            :key="item.id"
            @click="getCasesDetails(item.id)"
          >
            <!-- <div class="article_left"> -->
            <img :src="item.image" alt="" />
            <!-- </div> -->
            <div class="article_Right">
              <h1>{{ item.title }}</h1>
              <p>
                {{ item.desc }}
              </p>
              <span>{{ formatTime(item.create_time) }}</span>
            </div>
          </div>
        </div>
        <div class="paging">
          <!-- <div class="pagingLeft">
                          <span>每页</span>
                          <el-select v-model="pageSize" placeholder="请选择" @change="handleSizeChange">
                              <el-option v-for="item in pageSizesOptions" :key="item" :label="item" :value="item">
                              </el-option>
                          </el-select>
                          <span>条</span>
                      </div> -->
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getExample, getExampleType } from "../api/userApi";
export default {
  data() {
    return {
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示条数
      total: 0, // 总数据量
      activeCategory: null, // 当前选中的分类ID，null表示全部
      categoryList: [], // 分类列表
      caseList: [], // 案例列表
    };
  },
  async created() {
    // 获取用户信息
    this.getExample();
    this.getExampleType();
  },
  methods: {
    // 格式化时间戳
    formatTime(timestamp) {
      const date = new Date(timestamp * 1000);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}.${month}.${day}`;
    },
    async getExampleType() {
      try {
        const response = await getExampleType();
        if (response.code === 1) {
          this.categoryList = response.data;
        }
      } catch (error) {
        console.error("获取接口失败", error);
      }
    },
    async getExample() {
      try {
        const params = {
          page: this.currentPage,
          limit: this.pageSize,
          article_type_id: this.activeCategory, // 如果选择全部则不传此参数
        };
        const response = await getExample(params);
        if (response.code === 1) {
          this.caseList = response.data;
          this.total = response.count;
        }
      } catch (error) {
        console.error("获取接口失败", error);
      }
    },
    selectCategory(categoryId) {
      this.activeCategory = categoryId;
      this.currentPage = 1; // 切换分类时重置到第一页
      this.getExample();
    },
    // 每页条数变化
    handleSizeChange(val) {
      this.pageSize = val;
      this.getExample();
    },
    // 页码变化
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getExample();
    },
    // selectItem(categoryIndex, itemIndex) {
    //   // 更新选中状态
    //   this.$set(this.activeItems, categoryIndex, itemIndex);
    // },
    getCasesDetails(id) {
      this.$router.push(`/casesDetails?id=${id}`);
    },
  },
};
</script>

<style scoped lang="less">
.content {
  width: 100%;
  max-width: 87.5rem;
  margin: 0 auto;
}
.cases {
  .banner {
    background: url(../assets/banner2.png) no-repeat center/cover;
    width: 100%;
    height: 318px;
  }
}
.main {
  background-color: #f5f5f5;
  padding: 20px 0 45px 0;
  .classify {
    width: 100%;
    background: #ffffff;
    border-radius: 10px;
    margin-bottom: 20px;
    // display: flex;
    // align-items: center;
    .categories {
      display: flex;
      flex-direction: column;

      .category-group {
        //   border-bottom: 1px dashed #d8d8d8;
        background-image: linear-gradient(
          to right,
          #d8d8d8 50%,
          transparent 50%
        );
        background-size: 20px 1px; /* 控制虚线间距：10px 为总长度，50% 透明，50% 实色 */
        background-repeat: repeat-x;
        background-position: bottom; /* 底部边框 */
        display: flex;
        //   padding-left: 20px;
        padding: 25px 55px;
        box-sizing: border-box;
        h3 {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #121212;
          width: 8%;
          text-align: left;
          display: flex;
          align-items: center;
        }
        ul {
          width: 92%;
          display: flex;
          flex-wrap: wrap;
          li {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #121212;
            margin-right: 10px;
            // margin-bottom: 4px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 3px 10px;
            &.active,
            &.default-active {
              background: #175dc2;
              color: #fff;
              padding: 3px 10px;
              box-sizing: border-box;
            }
          }
        }
      }
      .category-group:last-child {
        background-size: 20px 0px;
      }
    }
  }
  .box {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-bottom: 35px;
    .article {
      display: flex;
      padding: 25px;
      background-color: #fff;
      border-radius: 10px;
      cursor: pointer;
      img {
        width: 207px;
        height: 138px;
      }
      .article_left {
        img {
          width: 100%;
        }
      }
      .article_Right {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        margin-left: 20px;
        h1 {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 17px;
          color: #333333;
        }
        p {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #666666;
          text-align: left;
          display: -webkit-box;
          -webkit-line-clamp: 3; /* 控制显示的行数 */
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 413px;
          height: 60px;
        }
        span {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #666666;
        }
      }
    }
  }
  .paging {
    display: flex;
    justify-content: flex-end;
    padding-right: 45px;
    // ::v-deep .el-pager li {
    //   background-color: transparent;
    // }
    // ::v-deep .el-pagination button:disabled {
    //   background-color: transparent;
    // }
    // ::v-deep .el-pagination .btn-next {
    //   background-color: transparent;
    // }
    // ::v-deep .el-pagination .btn-prev {
    //   background-color: transparent;
    // }
    ::v-deep .el-pager li,
    ::v-deep .el-pagination button:disabled,
    ::v-deep .el-pagination .btn-next,
    ::v-deep .el-pagination .btn-prev {
      background-color: transparent;
    }
  }
}
</style>
